const contentful = require("contentful");
export const client = contentful.createClient({
  space: "17g0rvry75o4",
  accessToken: "F41sAQxqpg5hgxtUIp210r2woL-hiu-d035GmCt9roo"
});